//@ts-check

import { BorderedPanel, MainContent, PageContent } from "~/components/Shared/PageParts";
import FormPreview from '~/components/AdminPages/ManageForms/FormPreview';
import { useParams } from "react-router";

export default function FormPreviewPage() {
    const { form_uuid: formId } = useParams();
    return (
        <MainContent>
            <PageContent noPageHead>
                <BorderedPanel className="zero-blue">
                    <FormPreview formId={formId} printPreview />
                </BorderedPanel>
            </PageContent>
        </MainContent>
    )
}